import { ColumnDetails, ColumnType } from '../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { html, TemplateResult } from 'lit';
import {
  getExchangeApplyToRuleGridOptions,
  getExchangeAntimalwareItemStatusGridValues,
  getExchangeRuleSendersGridOptions,
} from '../../../../../utils/uiSettings/exchange/exchange-protection.values';
import { ExchangeAntimalwareRule } from '@nirvana/shared/dtos/types/policies/common';
import { GridFilterUiConfiguration } from '../../../../../../../../types/filters/types';

export enum Column {
  PRIORITY = 1,
  NAME = 2,
  STATUS = 3,
  APPLY_TO = 4,
  SENDERS = 5,
  RECIPIENTS = 6,
}

export enum ColumnKeys {
  PRIORITY = 'defaultPositionInGrid',
  NAME = 'name',
  STATUS = 'active',
  APPLY_TO = 'applyTo',
  SENDERS = 'senders',
  RECIPIENTS = 'recipients',
}

export const GRID_COLUMNS = [
  Column.PRIORITY,
  Column.NAME,
  Column.STATUS,
  Column.APPLY_TO,
  Column.SENDERS,
  Column.RECIPIENTS,
];

export const FILTERS = [
  { [ColumnKeys.NAME]: { contains: '' } },
  { [ColumnKeys.STATUS]: { in: [] } },
  { [ColumnKeys.APPLY_TO]: { in: [] } },
];
export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.NAME, ColumnKeys.STATUS, ColumnKeys.APPLY_TO];
export const FILTERS_UI_CONFIGS: Array<GridFilterUiConfiguration> = [
  {
    key: ColumnKeys.STATUS,
    config: {
      allowSelectNone: true,
    },
  },
  {
    key: ColumnKeys.APPLY_TO,
    config: {
      allowSelectNone: true,
    },
  },
];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.PRIORITY,
      key: ColumnKeys.PRIORITY,
      columnName: translateFn('Priority'),
      type: ColumnType.NUMBER,
      removable: false,
      filteringDisabled: true,
    },
    {
      column: Column.NAME,
      key: ColumnKeys.NAME,
      columnName: translateFn('Rule name'),
      type: ColumnType.STRING,
      removable: false,
      sortable: false,
      editingDisabled: true,
    },
    {
      column: Column.STATUS,
      key: ColumnKeys.STATUS,
      columnName: translateFn('Status'),
      values: getExchangeAntimalwareItemStatusGridValues(),
      type: ColumnType.ENUM,
      removable: false,
      sortable: false,
      editingDisabled: true,
    },
    {
      column: Column.APPLY_TO,
      key: ColumnKeys.APPLY_TO,
      columnName: translateFn('Applies to'),
      values: getExchangeApplyToRuleGridOptions(),
      type: ColumnType.ENUM,
      removable: false,
      sortable: false,
      editingDisabled: true,
    },
    {
      column: Column.SENDERS,
      key: ColumnKeys.SENDERS,
      columnName: translateFn('Senders'),
      values: getExchangeRuleSendersGridOptions(),
      type: ColumnType.ENUM,
      removable: false,
      sortable: false,
      editingDisabled: true,
      filteringDisabled: true,
    },
    {
      column: Column.RECIPIENTS,
      key: ColumnKeys.RECIPIENTS,
      columnName: translateFn('Recipients'),
      values: getExchangeRuleSendersGridOptions(),
      type: ColumnType.ENUM,
      removable: false,
      sortable: false,
      editingDisabled: true,
      filteringDisabled: true,
    },
  ];
}

export function nameCellCustomRenderer(
  dispatchClickEventFn: (item) => void,
  rowData: unknown & { item: ExchangeAntimalwareRule }
): TemplateResult {
  // default rule must be translated
  const cellValue = rowData.item.default ? translateFn('Default rule') : rowData.item.name;
  return html` <span
    class="accent cell-label"
    style="cursor: pointer"
    @click="${() => dispatchClickEventFn(rowData.item)}"
    >${cellValue}</span
  >`;
}

export function statusCellCustomRenderer(rowData: unknown & { item: ExchangeAntimalwareRule }): TemplateResult {
  const cellText = rowData.item.active ? translateFn('Enabled') : translateFn('Disabled');
  return html`<span class="cell-label">${cellText}</span>`;
}
